import { render, staticRenderFns } from "./edit-cert.vue?vue&type=template&id=435201b7&scoped=true&"
import script from "./edit-cert.vue?vue&type=script&lang=js&"
export * from "./edit-cert.vue?vue&type=script&lang=js&"
import style0 from "./edit-cert.vue?vue&type=style&index=0&id=435201b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435201b7",
  null
  
)

export default component.exports